import { BaseCRUD } from '../CRUD';
import {
	deleteProcessingGeometries,
	updateProcessingGeometries,
} from '../../api/api-project';

export class ProcessingGeometry extends BaseCRUD {
	constructor(feature) {
		super();
		Object.keys(feature).forEach((key) => (this[key] = feature[key]));
	}

	get() {}

	create() {}

	update(idProcessingGeometry, geometryData) {
		return updateProcessingGeometries(
			idProcessingGeometry,
			geometryData,
		).then((res) => {
			const geometry = res.data.data;
			Object.keys(geometry).forEach((key) => (this[key] = geometry[key]));
		});
	}

	async delete(idProcessingGeometry, callb) {
		return deleteProcessingGeometries(idProcessingGeometry).then(() => {
			callb();
		});
	}
}
